module.exports = __webpack_public_path__ + "static/media/editor_qt.65a3576d.png";